import React from "react";

export default () => (
  <div className="text-center">
    <div className="spinner-border m-5 text-primary" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
